module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ep"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("In her forties now she’d be, I don’t know, fifty, girding up her lovely little loins, getting ready for the change.")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("—Samuel Beckett, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("All That Fall")])]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("I know those are your hands … I know it, but to me they are white tarantulas, don’t touch me.")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("—Katherine Anne Porter, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Pale Horse, Pale Rider")])]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Have you heard that poor, dear Blanche ")]), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("Got run down by an avalanche?")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("—Cole Porter, “Well, Did You Evah?”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0